import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { useSearchObject } from 'hooks/location';
import authActions from 'actions/auth-actions';
import { buildChildSitePath, ROOT_PATH } from 'constants/route-paths';
import { INVALID_REQUEST_MESSAGE } from 'constants/common';
import { isMfaChallengeResponse } from 'utils/mfa';

const SignInWithToken = () => {
  const { siteSlug } = useParams();

  const dispatch = useDispatch();

  const { token, redirectTo } = useSearchObject();

  const redirectToPath = redirectTo || (siteSlug ? buildChildSitePath(siteSlug) : ROOT_PATH);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isEmpty(token)) {
      dispatch(authActions.signInWithToken(token)).then((responseAction) => {
        // RouteValidation takes the user to the second factor and resumes here, replaying the link
        if (isMfaChallengeResponse(get(responseAction, 'payload.data'))) return;

        setLoading(false);
      });
    } else {
      setLoading(false);
      toast.error(INVALID_REQUEST_MESSAGE);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? <Spinner className='m-auto' animation='border' /> : <Redirect to={redirectToPath} />;
};

export default SignInWithToken;
